export class CfetNavLinksConstant {
    public static CFETNAVLINKS = {
        header_links: {
            'firstnet_home_page': 'https://www.firstnet.com',
            'header_about_link': 'https://www.firstnet.com/power-of-firstnet.html',
            'header_devices_link': 'https://www.firstnet.com/devices.html',
            'header_plans_link': 'https://www.firstnet.com/plans.html?tabs=c07d2611-ffc6-4983-8fc0-22b0de674150',
            'header_offers_link': 'https://www.firstnet.com/offers/individual-first-responders.html',
            'header_agency_signup': 'https://www.firstnet.com/agency-signup.html',
            'header_have_questions': 'https://www.firstnet.com/faq.html',
            'check_eligibility_link': '/signup/orgAssignment',
            'cfet_home_page': '/signup/landing'
        },
        footer_links: {
            firstnet_central: 'https://localcontrol.firstnet.att.com/',
            devices_services: 'https://wireless.firstnet.att.com/b2bservlets/HaloSSOLoginServlet.dyn',
            about_firstnet: 'https://www.firstnet.com/',
            firstnet_site_map: 'https://www.firstnet.com/',
            privacy_policy: 'https://www.firstnet.com/privacy-policy.html',
            terms_of_use: 'https://www.firstnet.com/terms-and-conditions.html',
            contact_us: 'https://wireless.firstnet.att.com/business/contacts/',
            intellectual_property: 'https://www.att.com/gen/privacy-policy?pid=2587',
            intellectual_property_activation: 'https://www.att.com/',
            personal_information: 'https://about.att.com/csr/home/privacy/rights_choices.html',
            health_notice: 'https://about.att.com/privacy/StateLawApproach/washington-health-privacy-notice.html'
        },
        utf_header_links: {
            'check_eligibility_link': '/signup/orgAssignment'
        }
    };
}
